import { Company, Note, TUserId } from '/src/lib/models';
import { Address, Phone, Region, TBaseQuery } from '/src/lib/types';

/**
 * Enums
 */
export enum CompanyStatus {
  Active = 'active',
  Inactive = 'inactive',
  Closed = 'closed',
  WorkOut = 'work-out',
  Suspended = 'suspended',
}

export enum SocketLineOfBusiness {
  Tech = 'Tech',
  Medical = 'Medical',
  HardGoods = 'HardGoods',
  Food = 'Food',
  Media = 'Media',
  Service = 'Service',
  Energy = 'Energy',
  Lender = 'Lender',
  Investor = 'Investor',
  Other = 'Other',
}

/**
 * List Companies
 */
export type TListCompaniesRequest = TBaseQuery;

export type TListCompaniesResponse = Company[];

/**
 * Get Company
 */
export type TGetCompanyResponse = Company;

/**
 * Create Company
 */
export type CreateCompanyForm = {
  name: string;
  longName: string;
  street: string;
  city: string;
  state?: Region;
  zip: string;
  contactPerson: string;
  phonePrimary: string;
  phoneSecondary?: string;
  phoneFax?: string;
  email?: string;
  website?: string;
  socketLineOfBusiness?: SocketLineOfBusiness;
  companyType: string; // TODO: create CompanyType enum?
  isLender: boolean;
  notes: Note[];
  files: string[];
  [key: string]: any;
};

export type TCreateCompanyRequest = {
  name: string;
  longName: string;
  address: Address;
  contactPerson: string;
  phone: Phone;
  email?: string;
  website?: string;
  socketLineOfBusiness: SocketLineOfBusiness;
  companyType: string; // TODO: create CompanyType enum?
  notes: Note[];
  files: string[];
  isLender: boolean;
  status: CompanyStatus.Active;
  user: TUserId;
};

export type TCreateCompanyResponse = Company;

/**
 * Update Company
 */
export type TUpdateCompanyRequest = Company;

export type TUpdateCompanyResponse = Company;

/**
 * Delete Company
 */
export type TDeleteCompanyResponse = Company;
